import { render, staticRenderFns } from "./FeaturedTournamentsAmerican.vue?vue&type=template&id=4b5f72e8&scoped=true"
import script from "./FeaturedTournamentsAmerican.vue?vue&type=script&lang=js"
export * from "./FeaturedTournamentsAmerican.vue?vue&type=script&lang=js"
import style0 from "./FeaturedTournamentsAmerican.vue?vue&type=style&index=0&id=4b5f72e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5f72e8",
  null
  
)

export default component.exports